module.exports = "\n<button class=\"btn btn-cancel\" ng-click=\"cancelFunction()\">{{textCancelBtn}}</button>\n\n<button class=\"btn btn-success\" ng-click=\"callFunction()\" ng-disabled=\"saving\" >\n    <i ng-show=\"saving\" class=\"fa fa-spinner fa-spin\" style=\"min-width: 50px\"></i> {{textBtn}}\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/modal.save.button.html
// module id = 214
// module chunks = 0